import React from "react";
import LabeledSelect from "../labeledSelect/labeledSelect.js";
export default function CountProvider(props) {
    const { provider } = props;
    const options = props.formatNames.map((format) => ({
        value: format,
        label: format,
    }));
    return (React.createElement("div", { className: "" },
        React.createElement(LabeledSelect, { label: "Format", placeholder: "Wybierz format...", options: options, defaultValueIndex: options.findIndex((f) => provider.formatName === f.value), onChange: (newFormat) => props.onProviderUpdate({ ...provider, formatName: newFormat }) })));
}
